const EMAIL_DOMAIN = import.meta.env.VITE_INTERNAL_EMAIL_DOMAIN;

export const generateEmailFromVesselName = (vesselName: string): string => {
  const sanitized = vesselName
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '.') // spaces to dots
    .replace(/[^a-z0-9.]/g, '') // remove special chars
    .replace(/\.+/g, '.') // collapse multiple dots
    .replace(/^\.+|\.+$/g, ''); // trim dots

  return `${sanitized}@${EMAIL_DOMAIN}`;
};
